export function* RandomFloat(
  n: number,
  min: number,
  max: number,
  seed: number
): IterableIterator<number> {
  let state = seed >>> 0 // force unsigned 32-bit

  for (let i = 0; i < n; i++) {
    // LCG parameters (Numerical Recipes)
    state = (1664525 * state + 1013904223) >>> 0
    yield (state / 0xffffffff) * (max - min) + min // scale to [min, max)
  }
}
